<template>
  <thead class="table-heading table-shadow">
    <tr class="th-auto pt-2">
      <th rowspan="2" class="text-center text-dark pa-1 table-shadow">
        <div
          v-if="!disablePeriod"
          class="d-flex d-inline-block mb-2 min-wx-250"
        >
          <v-icon size="25" color="#000">mdi-calendar-month-outline</v-icon>
          <span class="align-self-center text-muted">Periodo: </span>
          <custom-select
            v-model="period"
            :disabled="loading"
            class="ml-2 max-wx-50"
            theme="red"
            :options="periodOptions"
            :placeholder="'Seleccionar periodo'"
          />
        </div>
        <div class="d-flex justify-center">
          <div class="align-self-end">
            {{ columnTitle }}
            <span class="d-flex justify-center ma-0">
              <sort-by-button
                v-if="!loading"
                :data="users"
                column="userNameShort"
                icon-up="mdi-arrow-up"
                icon-down="mdi-arrow-down"
                @sortedData="$emit('sortedData', $event)"
              />
            </span>
          </div>
        </div>
      </th>
      <th
        v-for="(header, index) in topHeaders"
        :key="index"
        :rowspan="header.rowspan"
        :colspan="header.colspan"
        class="text-center pa-0 table-shadow"
      >
        <div
          class="d-flex h-100 flex-column text-nowrap pb-0 pt-0 pl-1 pr-1 text-secondary-2 text-dark"
          :class="header.class"
        >
          <span class="pre-line">{{ header.title }}</span>
          <v-tooltip v-if="header.value === 'TOTCTE'" bottom>
            <template #activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
            </template>
            <span class="pre-line">
              {{ `# de clientes / Facturación / \n Ticket promedio` }}</span
            >
          </v-tooltip>
          <sort-by-button
            v-if="header.sorted && !loading"
            :data="users"
            :column="header.value"
            type="number"
            icon-up="mdi-arrow-up"
            icon-down="mdi-arrow-down"
            @sortedData="$emit('sortedData', $event)"
          />
        </div>
      </th>
    </tr>

    <tr>
      <th
        v-for="(header, index) in headers"
        :key="index"
        class="text-center text-dark table-shadow pa-0"
      >
        <div
          class="d-flex justify-center flex-column text-nowrap pa-1 text-caption"
          :class="header.class"
        >
          <b class="pre-line">{{ header.title }}</b>
        </div>
      </th>
    </tr>
  </thead>
</template>

<script>
  import MixinDates from '@/mixins/dates';
  import service from '@/mixins/service';

  import CustomSelect from '@/components/CustomSelect.vue';
  import SortByButton from '@/components/SortByButton.vue';

  export default {
    name: 'UsersTableHeader',
    components: { CustomSelect, SortByButton },
    mixins: [MixinDates, service],
    props: {
      columnTitle: {
        type: String,
        default: 'Zona',
      },
      users: {
        type: Array,
        default: () => [],
      },
      loading: {
        type: Boolean,
        default: true,
      },
      disablePeriod: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        period: {},
        periodOptions: [],
        topHeaders: [
          {
            title: 'ingresos',
            sorted: true,
            rowspan: 2,
            colspan: 1,
            value: 'salaryThisMonth',
            class: 'justify-end',
          },
          {
            title: 'Pagos \n en \n IEL ',
            sorted: false,
            rowspan: 2,
            colspan: 1,
            value: '',
            class: 'justify-center',
          },
          {
            title: 'Crédito',
            sorted: false,
            rowspan: 1,
            colspan: 4,
            class: 'justify-center',
            value: '',
          },
          {
            title: '# de clientes / \n Con compra / \n % Cobertura',
            sorted: false,
            rowspan: 2,
            colspan: 1,
            class: 'justify-center',
          },
          {
            title: 'Clientes \n nuevos',
            sorted: true,
            rowspan: 2,
            value: 'customers.newCustomers',
            colspan: 1,
            class: 'justify-end',
          },
          {
            title: 'Renglonaje',
            sorted: true,
            value: 'assortment',
            rowspan: 2,
            colspan: 1,
            class: 'justify-end',
          },
          {
            title: 'Facturación',
            sorted: false,
            rowspan: 1,
            colspan: 2,
            class: 'justify-center',
          },
          {
            title: 'Prom. \n Compra últ. \n 6 meses',
            sorted: false,
            rowspan: 2,
            colspan: 1,
            class: 'justify-center',
          },

          {
            title: 'Presupuesto',
            sorted: false,
            rowspan: 2,
            colspan: 1,
            class: 'justify-center',
          },
          {
            title: 'Pedidos \n%',
            sorted: false,
            rowspan: 2,
            colspan: 1,
            class: 'justify-center',
          },
          {
            title: 'Facturación \n %',
            sorted: false,
            rowspan: 2,
            colspan: 1,
            class: 'justify-center',
          },
          {
            title: 'Backorder',
            sorted: true,
            value: 'backorders.availableCount',
            rowspan: 2,
            colspan: 1,
            class: 'justify-end',
          },
          {
            title: 'Crecimiento \n acumulado',
            sorted: false,
            rowspan: 2,
            colspan: 1,
            class: 'justify-center',
          },
          {
            title: 'Presupuesto \n acumulado',
            sorted: true,
            value: 'billingVsBudgetPer',
            rowspan: 2,
            colspan: 1,
            class: 'justify-end',
          },
        ],
        headers: [
          {
            title: 'Límite ',
            sorted: false,
            rowspan: 1,
            colspan: 1,
            class: '',
          },
          {
            title: 'Disponible',
            sorted: false,
            rowspan: 1,
            colspan: 1,
            class: 'text-nowrap pa-1 text-caption',
          },
          {
            title: 'Vencido',
            sorted: false,
            rowspan: 1,
            colspan: 1,
            class: 'text-nowrap pa-1 text-caption',
          },
          {
            title: 'Pagaré',
            sorted: false,
            rowspan: 1,
            colspan: 1,
            class: 'text-nowrap pa-1 text-caption',
          },
          {
            title: 'PNC',
            sorted: false,
            rowspan: 1,
            colspan: 1,
            class: '',
          },
          {
            title: 'Gen. N',
            sorted: false,
            rowspan: 1,
            colspan: 1,
            class: '',
          },
        ],
      };
    },
    watch: {
      period(newValue) {
        this.$emit('periodChanged', newValue);
      },
    },
    created() {
      const periods = this.calcularUltimosMeses(12);
      this.periodOptions = periods.map((period) => {
        return { value: this.periodFormat(period), label: period.date };
      });
      this.period = this.periodOptions[0].value;
    },
    methods: {},
  };
</script>

<style scoped>
  .table-shadow {
    box-shadow: inset 0px 3px 6px #00000029, 0px 3px 6px #00000029;
    border: 1px inset 0px 3px 6px #00000029, 0px 3px 6px #00000029;
  }
</style>
